<!--
 This is the same component as in search.
 If you make this component evolve, make the one in match-search evolve too
 @see https://github.com/bureaux-a-partager/match-search/blob/master/src/components/ui/Toggle.vue
-->
<template>
  <div class="toggle-component" @click="onChange">
    <div class="toggle-component__button">
      <span class="switch">
        <input id="checkbox-toggle" type="checkbox" :checked="value">
        <span class="slider round" />
      </span>
    </div>
    <label
      v-if="label"
      for="checkbox-toggle"
      class="toggle-component__label"
      @click="onChange"
    >
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, required: true },
    label: { type: String, default: '' },
  },
  methods: {
    onChange() {
      this.$emit('onchange');
    },
  },
};
</script>
